module.exports = __webpack_public_path__ + "img/honor1.a32a4d48.png";